import { HW_API_URL } from "../../configs";
import { fetcher } from "../../libs";

import { CouponCheckParams, CouponCheckResponse } from "./types";

/**
 * Coupon lookup is being migrated from php-api to hunkware-api
 * (`docs/migrations/coupon-lookup/`).
 *
 * Transport-only: the Node contract reproduces the legacy wire shape bug-for-bug — the same
 * five-field coupon, the same `meta` envelope, the same three 400 messages — so the payload and
 * every response read are unchanged. An absolute URL bypasses the fetcher's `baseURL`
 * (php-api's `/public/website`) while keeping its casing transforms and, more importantly, its
 * error interceptor: this caller's whole failure UX is a rejected promise, and the interceptor
 * reads `meta.status`, `meta.series` and `meta.errors[].http_code` off the legacy envelope.
 *
 * No credential is sent either way. The Node route is mounted `@Public()`, matching php-api's
 * `allow_anonymous_login => true` — the legacy wrapper force-injects the Scorpion service account
 * server-side, so there was never a caller credential to carry over.
 *
 * Direct concatenation is safe here: booking-v4 sets `VITE_HW_API_URL` to the bare `/api` mount in
 * every environment. booking-v1/v2 scope theirs to `/api/v1/booking` and must use `buildHwApiUrl`.
 *
 * @param useNode value of the `HunkWare_Taxes_Coupons_Commissions_Node_Migration` flag. Roll back
 *   by turning the flag off — no deploy needed. **The flag is shared with hunkware-ui's job billing
 *   dialog and crew-app's coupons page**, so a rollback reverts those too (doc 07).
 */
const NODE_COUPON_LOOKUP_URL = `${HW_API_URL}/v1/public/website/coupons/lookup`;

export const couponCheck = ({
  couponCode,
  useNode = false,
}: CouponCheckParams) =>
  fetcher.get<CouponCheckResponse>(
    useNode ? NODE_COUPON_LOOKUP_URL : "/coupons/lookup",
    { params: { couponCode } },
  );
